import { render, staticRenderFns } from "./PolyIntegerReferenceCreate.vue?vue&type=template&id=06ae916f&"
import script from "./PolyIntegerReferenceCreate.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceCreate.vue?vue&type=script&lang=js&"
import style0 from "./PolyIntegerReferenceCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports